"use client";

import { StyleProvider, extractStyle } from "@ant-design/cssinjs";
import CacheEntity from "@ant-design/cssinjs/es/Cache";
import { useServerInsertedHTML } from "next/navigation";
import React, { useId, useRef } from "react";

const StyledComponentsRegistry = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // createCache() seeds its id with Math.random(), which aborts Cache Components prerenders.
  const cache = new CacheEntity(useId());
  const isServerInserted = useRef(false);

  useServerInsertedHTML(() => {
    if (!isServerInserted.current) {
      isServerInserted.current = true;
      return (
        <style
          id="antd"
          dangerouslySetInnerHTML={{ __html: extractStyle(cache, true) }}
        />
      );
    }
  });

  if (typeof window !== "undefined") return <>{children}</>;
  return <StyleProvider cache={cache}>{children}</StyleProvider>;
};

export default StyledComponentsRegistry;
